    <div>

    <h2>Resposta Especialista</h2>

    <div class="center">
      <ngx-datatable
        #table 
        class='material' 
        [columns]="columns" 
        [headerHeight]="50"
        [footerHeight]="50" 
        [rowHeight]="'auto'" 
        [rows]="rows"
      >
        <ngx-datatable-column name="Data" prop="created_at" [sortable]="false" [width]="200">
          <ng-template ngx-datatable-cell-template let-row="row">
            {{ row.created_at | date:'dd/MM/yyyy H:mm' }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Especialista" prop="usuario.name" [sortable]="false" [width]="200">
          <ng-template ngx-datatable-cell-template let-row="row">
            {{ row.usuario.name }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Cliente Aceitou" prop="cliente_aceitou" [sortable]="false" [width]="100">
          <ng-template ngx-datatable-cell-template let-row="row">
            {{ row.cliente_aceitou ? 'Sim' : 'Não' }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Valor" prop="valor" [sortable]="false" [width]="100">
          <ng-template ngx-datatable-cell-template let-row="row">
            {{ row.valor | currency:'BRL' }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Resposta" prop="resposta" [sortable]="false" [width]="200">
          <ng-template ngx-datatable-cell-template let-row="row">
            {{ row.resposta }}
          </ng-template>
        </ngx-datatable-column>
        <ngx-datatable-column name="Ações" [sortable]="false" [width]="100">
          <ng-template ngx-datatable-cell-template let-row="row">
            <button mat-mini-fab color="warning" style="margin-left: 10px; background-color: red; width: 30px; height: 30px;" matTooltip="Deletar" (click)="excluirItem(row)">
              <mat-icon style="font-size: 18px; margin-bottom: 5px;">delete</mat-icon>
          </button>
          </ng-template>
        </ngx-datatable-column>
      </ngx-datatable>
    </div>
  </div>
  